module.exports = __webpack_public_path__ + "assets/images/project/satellite-gifs/nongsa-desktop.gif?v=c61cd84d";